<template>
  <div class="content-cluster" :class="clusterId" :data-index="clusterIndex">
    <div class="content-cluster__container content-cluster__container--left">
      <Content
        v-for="(content, id) in pageContent.contents"
        :key="id"
        :contents="content"
        @complete="showButtons"
      />
    </div>

    <div class="content-cluster__container content-cluster__container--right">
      <transition-group
        name="show-button"
        appear
        @enter="onButtonEnterAnimation"
        @afterEnter="onButtonAnimationDone"
      >
        <QueryButton
          v-for="(button, id, index) in buttons"
          :key="button.action"
          :button="button"
          :id="id"
          :clusterIndex="clusterIndex"
          :data-index="index"
          @onButtonClick="onButtonClick"
          ref="queryButton"
        />
      </transition-group>

      <transition name="show-bar">
        <!-- <div class="bar" v-show="buttonAnimationDone"></div> -->
      </transition>
    </div>
  </div>
</template>


<script>
import QueryButton from "./QueryButton";
import Content from "./Content";

export default {
  name: "ContentCluster",
  components: {
    Content,
    QueryButton
  },
  props: ["pageContent", "clusterIndex", "cluster-id"],
  data() {
    return {
      buttons: null,
      buttonAnimationDone: false
    };
  },
  methods: {
    onButtonClick() {
      //this.$el.style["min-height"] = 0;
    },
    showButtons() {
      this.buttons = this.pageContent.buttons;
    },
    onButtonEnterAnimation(el) {
      const delay = el.dataset.index * 150;
      el.style.transitionDelay = `${delay}ms`;

      this.$store.commit("CHECKHEIGHT");
    },
    onButtonAnimationDone(el) {
      const index = parseInt(el.dataset.index);
      const arrLength = this.$refs.queryButton.length;

      this.$store.commit("CHECKHEIGHT");

      el.removeAttribute("style");

      if (index === arrLength - 1) {
        this.buttonAnimationDone = true;
        this.$store.commit("UNLOCK_APP");
      }
    }
  }
};
</script>


<style lang="scss">
.content-cluster {
  width: 100%;
  text-align: left;
  max-width: 1100px;
  margin: auto;

  min-height: 55vh;
  &:not(:last-child) {
    min-height: 0vh;
  }

  transition: min-height .5s ease-out;
  //background-color: red;
  padding: 10px 0 50px 0;

  background-color: transparent;
  // background: linear-gradient(135deg,  $color-background0 0%, darken($color-background0, 8) 100%);
  //box-shadow: 0px 5px 10px 3px rgba(0,0,0,0.1);

  // &:nth-child(2n+0){
  //   background-color: $color-background1;
  //   // background: linear-gradient(135deg,  $color-background1 0%, darken($color-background1, 8) 100%);
  // }

  &:last-child {
    display: block !important;
  }

  &__container {
    //margin: 0.5em 0 0.5em;
  }

  &__container--left {
    text-align: left;
    padding: 10px 20px 0 20px;
  }

  &__container--right {
    position: relative;
    display: flex;
    flex-flow: wrap;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 10px 20px 0 20px;
    perspective: 350px;
    
  }

  @include device-from($device-small) {
    min-height: 65vh;

    &__container--left {
      margin-right: 50%;
      padding: 0 10px 0 10px;
    }

    &__container--right {
      margin-left: 50%;
      justify-content: flex-start;
      padding: 0 10px 0 10px;
    }
  }
}

// .content-cluster.start{
//   background-color: #581644;
// }

// .content-cluster.tell{
//   background-color: #91003e;
// }

// .content-cluster.contact{
//   background-color: #c9003b;
// }

// .content-cluster.what{
//   background-color: #ff4d3c;
// }

// .content-cluster.work{
//   background-color: #ffc033;
// }

// .content-cluster.different{
//   background-color: #ffc033;
// }

// .content-cluster.when{
//   background-color: #ff4d3c;
// }


.show-button-enter-active,
.show-button-leave-active {
  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.show-button-enter, .show-button-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scale(0.8) rotateX(-120deg);
  opacity: 0;
}

.show-bar-enter-active,
.show-bar-leave-active {
  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.show-bar-enter, .show-bar-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scaleX(0.8);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentCluster.vue